import { Component } from '@angular/core';
import { MenuSharedService } from '../Core/services/menu-shared.service';

@Component({
  selector: 'default',
  templateUrl: './default.component.html',

})
export class DefaultComponent {

  constructor( public menuSharedService : MenuSharedService) {
    this.menuSharedService.refreshMenu();
  }
}
